import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";
import { useAuth } from "context/authContext.js";
import { msalInstance, loginRequest } from "authConfig.js";
import BeatLoader from "react-spinners/BeatLoader";
import { useAccessToken } from "context/tokenConfig.js";
import { baseurl } from "authConfig.js";
import { useRoleToken } from "context/roleContext";
import { useClient } from "context/clientContext";
import ClientSelection from "components/SelectClient";
import { useHasChecked } from "context/hasCheckedContext";
import FolderTable from "./components/FolderTable.js"

const Dashboard = () => {

  const [awaitingArray, setAwaitingArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [authorisedArrayAdmin, setAuthorisedArrayAdmin] = useState([]);
  const [authorisedArrayPayroll, setAuthorisedArrayPayroll] = useState([])
  const [previousFileSize, setPreviousFileSize] = useState()
  const [currentFileSize, setCurrentFileSize] = useState()
  const [lastUpdated, setLastUpdated] = useState()
  const [mostRecentUploadDate, setMostRecentUploadDate] = useState()
  const [previousFileSizePay, setPreviousFileSizePay] = useState()
  const [currentFileSizePay, setCurrentFileSizePay] = useState()
  const [archivedFiles, setArchivedFiles] = useState([])
  const [updatedAwaitingArray, setUpdatedAwaitingArray] = useState([]);
  const [updatedAuthorisedArrayAdmin, setUpdatedAuthorisedArrayAdmin] = useState([])
  const [updatedAuthorisedArrayPayroll, setUpdatedAuthorisedArrayPayroll] = useState([])
  const { login } = useAuth();
  const { hasChecked, setHasChecked } = useHasChecked()

  const [data, setData] = useState([])
  const { accessToken } = useAccessToken();
  const { client, selectedClient } = useClient();

  const handleLogin = () => {
    msalInstance
      .loginPopup(loginRequest)
      .then(async (response) => {
        console.log("Login successful:", response);
        await login(); 
        window.location.reload();
      })      
      .catch(error => {
        console.error("Login error:", error);
      });
  };
  
  const getDocumentData = async () => {
    setIsLoading(true)
    try {
      const url = `${baseurl}/GetWebPresentationData?ClientId=${selectedClient}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setData(data);
        setIsLoading(false)
      } else {
        console.error('Failed to fetch document data', response.status);
        setIsLoading(false)
      }
    } catch (error) {
      console.error("Error in getDocumentData:", error);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    if (accessToken && selectedClient !== -1) {
      getDocumentData();
    }

    if (selectedClient > 0) {
      setHasChecked(true)
    }
  }, [accessToken, selectedClient]);


    useEffect(() => {
      const getToken = async () => {
        try {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length === 0) {
            throw new Error('No accounts available');
          }
  
        } catch (error) {
          console.error('Error acquiring token:', error);
        }
      };
  
      getToken();
    }, []);

  useEffect(() => {

    const awaiting = data?.filter(item => item?.authorisedDate === null);
    const archived = data?.filter(item => item?.clientFileStage === "A")

    const typeOfFile = data.filter(
  item => item?.folderLabel?.toLowerCase() === "admin"
);
    const previousFile = typeOfFile.filter(item => item?.clientFileStage === "P");
    const currentFile = typeOfFile.filter(item => item?.clientFileStage === "C");

    const filteredPandC = [...previousFile, ...currentFile];

    const typeOfFilePay = data.filter(item => item?.folderLabel?.toLowerCase() === "payroll");
    const previousFilePay = typeOfFilePay.filter(item => item?.clientFileStage === "P");
    const currentFilePay = typeOfFilePay.filter(item => item?.clientFileStage === "C");

    const filteredPandCPay = [...previousFilePay, ...currentFilePay];

    const authorisedA = [...filteredPandC]

    const authorisedB = [...filteredPandCPay]

    const recentDate = data
    .map(item => new Date(item?.authorisedDate))
    .filter(date => !isNaN(date))
    .reduce((max, date) => (date > max ? date : max), new Date(0));

    const isDefaultDate = recentDate.toISOString() === "1970-01-01T00:00:00.000Z";
    
  const lastUpdated = isDefaultDate
    ? "Never"
    : (() => {
        const now = new Date();
        const currentUTC = new Date(
          Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
        );

        const recentUTC = new Date(
          Date.UTC(recentDate.getUTCFullYear(), recentDate.getUTCMonth(), recentDate.getUTCDate())
        );

        const timeDifference = currentUTC - recentUTC;
        const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        if (dayDifference === 0) {
          return "Today";
        } else if (dayDifference === 1) {
          return "One Day Ago";
        } else {
          return `${dayDifference} Days Ago`;
        }
      })();

    setAwaitingArray(awaiting);
    setAuthorisedArrayAdmin(authorisedA);
    setAuthorisedArrayPayroll(authorisedB)
    setPreviousFileSize(previousFile);
    setCurrentFileSize(currentFile);
    setPreviousFileSizePay(previousFilePay)
    setCurrentFileSizePay(currentFilePay)
    setArchivedFiles(archived)
    setMostRecentUploadDate(recentDate);
    setLastUpdated(lastUpdated); 
  }, [data]);


  useEffect(() => {
    const updatedArray = awaitingArray.map(item => {
      const isDuplicate =
        authorisedArrayAdmin.some(
          authItem =>
            authItem.filename === item.filename && authItem.fileSize === item.fileSize
        ) ||
        archivedFiles.some(
          archivedItem =>
            archivedItem.filename === item.filename && archivedItem.fileSize === item.fileSize
        );
  
      return { ...item, hasDuplicate: isDuplicate };
    });
  
    const sortedDocuments = updatedArray.sort((a, b) => {
      return new Date(b.uploadDate) - new Date(a.uploadDate);
    });
  
    setUpdatedAwaitingArray(sortedDocuments);

    const sortedAuthAdminDocuments = authorisedArrayAdmin.sort((a, b) => {
      return new Date(b.uploadDate) - new Date(a.uploadDate);
    });

    setUpdatedAuthorisedArrayAdmin(sortedAuthAdminDocuments)

    const sortedAuthPayrollDocuments = authorisedArrayPayroll.sort((a, b) => {
      return new Date(b.uploadDate) - new Date(a.uploadDate);
    });

    setUpdatedAuthorisedArrayPayroll(sortedAuthPayrollDocuments)

  }, [awaitingArray, authorisedArrayAdmin, archivedFiles]);
  

 const renderTable = (data) => (
  <Table>
    <thead>
      <tr>
        <th colSpan="3"></th>
        <th colSpan="3" style={{ borderBottom: "1px solid #EC2B20", textAlign: "center", fontWeight: "bold", color: "#EC2B20" }}>
          Validation Failures
        </th>
        <th></th>
      </tr>
      <tr style={{ color: "#201E1F" }}>
        {selectedClient === 0 && <th>Client Name</th>}
        <th>File Name</th>
        <th>Created On</th>
        <th>File Size (MB)</th>
        <th>File Type</th>
        <th>File Size (%)</th>
        <th>Duplicate File</th>
      </tr>
    </thead>
    <tbody>
      {data.map((i, index) =>
        i.clientFileStage === "R" ? null : (
          <tr key={index}>
            {selectedClient === 0 && <td>{i?.clientName}</td>}
            <td>{i?.filename}</td>
            <td>{new Date(i?.fileCreatedDate).toLocaleDateString("en-GB")}</td>
            <td>{i?.fileSize}</td>
            <td>{i?.failedFileExtensionCheck ? "Yes" : "No"}</td>
            <td>{i?.failedFileSizeTolerance ? "Yes" : "No"}</td>
            <td>{i?.hasDuplicate ? "Yes" : "No"}</td>
          </tr>
        )
      )}
    </tbody>
  </Table>
);

  return (
    <>
      <div className="content">
        {isLoading ?
          <div style={{ paddingTop: '150px', display: "flex", justifyContent: "center" }}>
            <BeatLoader color={"#EC2B20"} size={35} loading={isLoading} />
          </div>
          :
          <>
            {accessToken === null ?
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "100px 50px 100px 50px" }}>
                <p style={{ fontSize: "20px" }}>
                  Please log in to use this app
                </p>

                <Button
                  onClick={handleLogin}
                  style={{ backgroundColor: "#EC2B20", width: "25%" }}
                  block
                  className="btn-round"
                >
                  Log In
                </Button>
              </div>
              :
            <>
  {client === 0 && !hasChecked ? (
    <ClientSelection />
  ) : (
    hasChecked && (
                    <>
                <Row>
                  <Col lg="6" md="6" sm="6">
                    <Card className="card-stats">
                      <CardBody style={{ paddingBottom: "10px" }}>
                        <Row>
                          <Col md="4" xs="5">
                            <div className="icon-big text-start icon-warning">
                              <i style={{ color: "#EC2B20" }} className="nc-icon nc-calendar-60" />
                            </div>
                          </Col>
                          <Col md="8" xs="7">
                            <div className="numbers">
                              <p className="card-category">Last Updated</p>
                              <CardTitle style={{ fontSize: "20px", paddingTop: "10px" }} tag="p">{lastUpdated}</CardTitle>
                              <p />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="6" md="6" sm="6">
                    <Card className="card-stats">
                      <CardBody style={{ paddingBottom: "10px" }}>
                        <Row>
                          <Col md="4" xs="5">
                            <div className="icon-big text-start icon-warning">
                              <i style={{ color: "#EC2B20" }} className="nc-icon nc-badge" />
                            </div>
                          </Col>
                          <Col md="8" xs="7">
                            <div className="numbers">
                              <p className="card-category">Awaiting Authorisation</p>
                              <CardTitle style={{ fontSize: "20px", paddingTop: "10px" }}  tag="p">{updatedAwaitingArray?.length}</CardTitle>
                              <p />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>

                </Row>
<FolderTable
  data={updatedAwaitingArray}
  title="Awaiting Authorisation"
  renderTable={renderTable}
  emptyMessage="No files awaiting authorisation"
/>

<FolderTable
  data={updatedAuthorisedArrayAdmin}
  title="Recently Committed Admin Files"
  renderTable={(rows, handleSort, sortConfig) => (
    <Table>
      <thead className="text-primary">
        <tr style={{ color: "#2c2c2c" }}>
          {selectedClient === 0 && (
            <th>
              Client Name
              <button
                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                onClick={() => handleSort("clientName")}
              >
                {sortConfig.key === "clientName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
              </button>
            </th>
          )}
          <th>
            File Name
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("filename")}
            >
              {sortConfig.key === "filename" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Stage
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("clientFileStage")}
            >
              {sortConfig.key === "clientFileStage" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Date Created
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileCreatedDate")}
            >
              {sortConfig.key === "fileCreatedDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Uploaded Date
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("uploadDate")}
            >
              {sortConfig.key === "uploadDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Size (MB)
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileSize")}
            >
              {sortConfig.key === "fileSize" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        {rows.map((j, index) => (
          <tr key={j.id ?? index}>
            {selectedClient === 0 && <td>{j?.clientName}</td>}
            <td>{j.filename}</td>
            <td>{j.clientFileStage === "P" ? "Previous" : "Current"}</td>
            <td>{new Date(j?.fileCreatedDate).toLocaleDateString("en-GB")}</td>
            <td>{new Date(j?.uploadDate).toLocaleDateString("en-GB")}</td>
            <td>{j.fileSize}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )}
  emptyMessage="No recently committed admin files"
/>

  <FolderTable
  data={updatedAuthorisedArrayPayroll}
  title="Recently Committed Payroll Files"
  renderTable={(rows, handleSort, sortConfig) => (
    <Table>
      <thead className="text-primary">
        <tr style={{ color: "#2c2c2c" }}>
          {selectedClient === 0 && (
            <th>
              Client Name
              <button
                style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
                onClick={() => handleSort("clientName")}
              >
               {sortConfig.key === "clientName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
              </button>
            </th>
          )}
          <th>
            File Name
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("filename")}
            >
              {sortConfig.key === "filename" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
  <th>
            File Stage
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("clientFileStage")}
            >
              {sortConfig.key === "clientFileStage" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Date Created
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileCreatedDate")}
            >
              {sortConfig.key === "fileCreatedDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            Uploaded Date
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("uploadDate")}
            >
              {sortConfig.key === "uploadDate" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
          <th>
            File Size (MB)
            <button
              style={{ border: "none", marginLeft: "5px", backgroundColor: "white" }}
              onClick={() => handleSort("fileSize")}
            >
              {sortConfig.key === "fileSize" ? (sortConfig.direction === "asc" ? "↑" : "↓") : "⇅"}
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((j, index) => (
          <tr key={index}>
            {selectedClient === 0 && <td>{j?.clientName}</td>}
            <td>{j.filename}</td>
            <td>{j.clientFileStage === "P" ? "Previous" : "Current"}</td>
            <td>{new Date(j?.fileCreatedDate).toLocaleDateString("en-GB")}</td>
            <td>{new Date(j?.uploadDate).toLocaleDateString("en-GB")}</td>
            <td>{j.fileSize}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )}
  emptyMessage="No recently committed payroll files"
/>

            </>
))
}
              </>
            }
          </>
        }
      </div>
    </>
  );
}

export default Dashboard;
